import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { getFromStorage } from '../../utils/storage'
import { useState } from 'react'
import { useCallback } from 'react'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { currentUserActions } from '../../redux/store'
import { DOMAIN, api } from '../../utils/api'
import { Box, Button, Card, Chip, CircularProgress, Typography, useMediaQuery } from '@mui/material'
import CreateGuestOrderForm from '../../components/CreateGuestOrderForm'
import { mainGreen, mainRed } from '../../utils/color'

export default function GuestOrder() {
	const { storeId } = useParams()
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const [guestOrders, setGuestOrders] = useState([])
	const [loadingOrders, setLoadingOrders] = useState(true)
	const [showForm, setShowForm] = useState(false)
	const [order, setOrder] = useState()
	const [orderIndex, setOrderIndex] = useState()

	const getGuestOrders = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/admin/guest-order/${storeId}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setGuestOrders(response.data)
				setLoadingOrders(false)
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, storeId],
	)

	useEffect(() => {
		getGuestOrders()
	}, [getGuestOrders])

	const handleShowForm = (Boolean) => {
		setShowForm(Boolean)
	}

	const handleSubmit = async (orderData) => {
		const formData = new FormData()
		formData.append('quantity', orderData.quantity)
		formData.append('totalPrice', orderData.bill)
		formData.append(
			'detail',
			orderData.productInfo + ' ' + orderData.address + ' ' + orderData.name + ' ' + orderData.phone,
		)
		formData.append('payment', orderData.payment)
		formData.append('quickPurchase', false)
		formData.append('store', currentUser.store || storeId)
		formData.append('creator', currentUser.id)
		formData.append('app', false)

		try {
			await axios({
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				},
				url: api.POST_CREATE_ORDER,
				data: formData,
				withCredentials: true,
			})
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
		await approveGuestOrder(orderData._id)
	}

	const approveGuestOrder = async (id) => {
		try {
			await axios({
				url: api.APPROVE_GUEST_ORDER_ADMIN,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { id },
			})
			await getGuestOrders()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const deleteGuestOrder = async (id) => {
		try {
			await axios({
				url: api.DELETE_GUEST_ORDER_ADMIN,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { id },
			})
			await getGuestOrders()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			{loadingOrders ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<>
					<Box
						sx={{
							maxWidth: 992,
							margin: '0 auto',
						}}>
						{guestOrders?.length === 0 && (
							<Card sx={{ padding: '10px' }}>
								<Typography sx={{ fontWeight: 'bold' }}>Chưa có dữ liệu</Typography>
							</Card>
						)}
						{guestOrders?.map((order, index) => {
							return (
								<Card
									sx={{
										padding: '10px',
										mb: 1,
									}}
									key={index}>
									<Box
										sx={{
											display: 'flex',
											alignItems: 'flex-start',
											justifyContent: 'space-between',
										}}>
										<Box>
											<Typography>
												<b>Thời gian: </b>
												{order.createdAt}
											</Typography>
											<Typography>
												<b>Tên KH: </b>
												{order.name}
											</Typography>
											<Typography>
												<b>Khối lượng: </b>
												{order.quantity}kg
											</Typography>
											<Typography>
												<b>Chi tiết: </b>
												{order.productInfo}
											</Typography>
											<Typography>
												<b>Địa chỉ giao hàng: </b>
												{order.address}
											</Typography>
											<Typography>
												<b>Số điện thoại: </b>
												{order.phone}
											</Typography>
											{order.note && (
												<Typography>
													<b>Ghi chú: </b>
													{order.note}
												</Typography>
											)}
											<Typography>
												<b>Thanh toán: </b>
												{order.payment === 'transfer' && (
													<span style={{ color: mainGreen, fontWeight: 'bold' }}>Chuyển khoản</span>
												)}
												{order.payment === 'cash' && (
													<span style={{ color: mainGreen, fontWeight: 'bold' }}>Tiền mặt</span>
												)}
											</Typography>
											<Typography>
												<b>Tiền: </b>
												{order.bill.toLocaleString()}đ
											</Typography>
										</Box>
										<Chip sx={{ color: '#fff', background: mainGreen }} label={`ĐƠN ${index + 1}`} />
									</Box>
									<div style={{ display: 'flex', justifyContent: 'space-between' }}>
										<Box>
											<Button
												onClick={(e) => {
													e.stopPropagation()
													setOrderIndex(index + 1)
													setOrder(order)
													setShowForm(true)
												}}
												sx={{
													textTransform: 'none',
													padding: '2px 5px',
													mt: 1,
													mr: 2,
													background: mainRed,
													'&:hover': { background: mainRed },
												}}
												variant='contained'
												size='small'>
												Chỉnh sửa
											</Button>
											<Button
												onClick={() => {
													handleSubmit(order)
												}}
												sx={{
													textTransform: 'none',
													padding: '2px 5px',
													mt: 1,
													background: mainGreen,
													'&:hover': { background: mainGreen },
												}}
												variant='contained'
												size='small'>
												Duyệt đơn ngay
											</Button>
										</Box>
										<Button
											onClick={(e) => {
												e.stopPropagation()
												const confirmDelete = window.confirm('Bạn có chắc muốn hủy đơn hàng này?')
												if (confirmDelete) {
													deleteGuestOrder(order._id, order.store)
													alert('Hủy đơn hàng thành công!')
												}
											}}
											sx={{
												textTransform: 'none',
												padding: '2px 5px',
												mt: 1,
												background: mainRed,
												'&:hover': { background: mainRed },
											}}
											variant='contained'
											size='small'>
											Hủy đơn
										</Button>
									</div>
								</Card>
							)
						})}
					</Box>
				</>
			)}

			<Box
				position='fixed'
				sx={{
					bottom: 0,
					left: mediaMd ? 300 : 0,
					right: 0,
				}}>
				{showForm && currentUser.permission?.includes('manageAllGuestOrder') && (
					<CreateGuestOrderForm
						getGuestOrders={getGuestOrders}
						handleShowForm={handleShowForm}
						order={order}
						index={orderIndex}
						storeId={storeId}
					/>
				)}
			</Box>
		</UserLayout>
	)
}
